import { Component, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
  /** Rendered instead of the crashed subtree. Defaults to nothing. */
  fallback?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

// Minimal error boundary so a throwing child — e.g. lottie-web choking on a
// malformed animation — falls back gracefully instead of taking down the
// surrounding UI. Kept DS-local to avoid an external dependency.
export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  render(): ReactNode {
    if (this.state.hasError) return this.props.fallback ?? null
    return this.props.children
  }
}
